<script setup lang="ts">
  import { computed } from 'vue';
  import { NavigationItem, NavigationCategory } from '@/shared/lib';
  import NavigationTree from '@/shared/ui/navigation/NavigationTree.vue';

  interface Props {
    showCheckboxes?: boolean;
    showIcons?: boolean;
    items?: NavigationItem[];
    categoryInfo?: NavigationCategory;
  }

  const props = withDefaults(defineProps<Props>(), {
    showCheckboxes: true,
    showIcons: true,
    items: () => [],
    categoryInfo: () => ({
      id: 'quality-records',
      name: 'Registros da Qualidade',
      type: 'document',
      items: [],
    }),
  });

  const emit = defineEmits<{
    'item-selected': [item: NavigationItem];
    'items-selected': [items: NavigationItem[]];
    'item-navigate': [item: NavigationItem];
  }>();

  const navigationItems = computed(() => {
    return props.items || [];
  });
</script>

<template>
  <div>
    <NavigationTree
      :items="navigationItems"
      :show-checkboxes="showCheckboxes"
      :show-icons="showIcons"
      :category-info="categoryInfo"
      @item-click="emit('item-selected', $event)"
      @item-toggle="emit('item-selected', $event)"
      @item-expand="() => {}"
      @item-navigate="emit('item-navigate', $event)"
    />
  </div>
</template>
